"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const CreateAccount_1 = __importDefault(require("./CreateAccount"));
const InviteRole_1 = __importDefault(require("./InviteRole"));
const RosterMemberForm_1 = __importDefault(require("./RosterMemberForm"));
const TsPlusOffer_1 = __importDefault(require("./TsPlusOffer"));
const ts_plus_offer_1 = __importDefault(require("./ts-plus-offer"));
const useInvitation_1 = require("./useInvitation");
const react_router_dom_1 = require("react-router-dom");
const InvitationRoot = () => {
    const { path } = (0, react_router_dom_1.useRouteMatch)();
    React.useEffect(() => {
        // TODO amplitude tracking B2C-4731
    }, []);
    React.useEffect(() => {
        // separate global styles from account profile routes
        document?.body?.setAttribute('id', 'v1-invitation');
    }, []);
    return (React.createElement(useInvitation_1.InvitationContext.Provider, { value: (0, useInvitation_1.useInvitation)() },
        React.createElement(react_router_dom_1.Switch, null,
            React.createElement(react_router_dom_1.Route, { exact: true, path: `${path}/claim` },
                React.createElement(CreateAccount_1.default, null)),
            React.createElement(react_router_dom_1.Route, { exact: true, path: `${path}/role` },
                React.createElement(InviteRole_1.default, null)),
            React.createElement(react_router_dom_1.Route, { exact: true, path: `${path}/complete_roster` },
                React.createElement(RosterMemberForm_1.default, null)),
            React.createElement(react_router_dom_1.Route, { exact: true, path: `${path}/offer` },
                React.createElement(TsPlusOffer_1.default, null)),
            React.createElement(react_router_dom_1.Route, { exact: true, path: `${path}/offer/new` },
                React.createElement(ts_plus_offer_1.default, null)))));
};
exports.default = InvitationRoot;
